export const scriptParameterTypes: any = {
    application: 'select',
    variable: 'select'
};